const content = {
  header: {
    images: [
      '/images/IMG_2037.jpg',
      '/images/IMG_20250524_170616.jpg',
      '/images/IMG_7399.jpg',
      '/images/IMG_7491.jpg',
      // 他の画像パスをここに追加
    ],
    interval: 5000, // 画像切り替えの間隔（ミリ秒）
  },
  overview: {
    title: '主な活動',
    description: `私たちの目標は、XRの最先端に立つ技術を習得することです。
IVRCを始めとしたXRの様々な大会に出場し、XRのまだ見えない可能性に挑んでいます。
モーションキャプチャを用いたVtuberや本学八王子キャンパスを仮想空間上に再現するデジタルツインなどの活動も行っています。
日頃の活動から多くのXRイベント参加を通じて、BlenderやUnityといったソフトウェア面はもちろん、電子工作によるハードウェア面の技術力も向上させています。
私たちは、急速に変化するXR分野の最新技術を追いながら様々な技術に取り組み、社会の課題に挑戦し貢献していきます。`,
    mainActivities: [
      { title: '大会チーム', description: '大会チームは、XRのまだ見えない可能性に挑戦しています。IVRC(Interverse Virtual Reality Challenge)を始めとしたXRの様々な大会に出場しています。学部2年生の学生たちが主体となり、大会に出すゲームや装置を一から設計、開発しています。', image: '/images/IVRC2024.jpg' },
      { title: 'メタバースチーム', description: 'メタバースチームは、「既存の建物」「失われた建物」などを仮想空間上に再現する取り組みをしております。建造物の設計図から3Dオブジェクトとしてモデリングをし、メタバースなど3Dの空間上に再現する取り組みをしております。', image: '/images/Metaverse2024.jpg' },
      { title: 'VTuberチーム', description: 'VTuberチームでは、「自分たちにしかできない」VTuberコンテンツを制作、発信しております。VTuberキャラクターや動画企画を一から考案し、一から制作しております。', image: '/images/VTuber2024.jpg' },
    ],
  },
  teams: {
    contest: {
      title: '大会チーム',
      image: '/images/IVRC2024.jpg',
      overview: `大会チームは、XRのまだ見えない可能性に挑戦しています。
IVRC(Interverse Virtual Reality Challenge)を始めとしたXRの様々な大会に出場しています。
学部2年生の学生たちが主体となり、大会に出すゲームや装置を一から設計、開発しています。
学部2～3年生の早い時期に学会にて発表をし、聴講者に対する説明能力を磨いております。
大会チームでの経験は、将来の研究や就職活動において活きてくる「創造力」や「開発能力」「遂行能力」「リーダーシップ性」などを養えます。`,
      activities: [
        {
          year: '2022',
          items: [
            { title: 'IVRC2022出場', description: '4作品を応募し、2作品「超次元VR野球」「Pulled In The Air」が初出場にて書類審査を通過し、Seed Stageに進みました。' },
            { title: '本学新宿祭初出展', description: 'IVRC2022出展作品「超次元VR野球」「Pulled In The Air」の出展を行いました。', image: '/images/IVRC2022-shinjuku.jpg' },
          ],
        },
        {
          year: '2023',
          items: [
            { title: 'IVRC2023出場', description: '5作品を応募し、1作品「それいけ！ムササビスーツ」が書類審査を通過し、Seed Stageに進みました。' },
            { title: '本学八王子祭・新宿祭出展', description: 'IVRC2023出展作品「それいけ！ムササビスーツ」の出展を行いました。', image: '/images/IVRC2023-Hachioji.jpg' },
          ],
        },
        {
          year: '2024',
          items: [
            { title: 'IVRC2024出場', description: '3作品を応募し、1作品「Gravity Paradox」がLeap Stageに出場、Seed Stageにて観客賞を受賞しました。',image : '/images/IVRC2024.jpg' },
            { title: 'APMAR 2024国際学会発表', description: '「Gravity Paradox」の内容および団体について「APMAR」という国際学会にて、副代表が登壇し発表しました。',image : '/images/APMAR2024.jpg' },
            { title: '情報処理学会での研究発表', description: '本作品を情報処理学会 Interactionにてプレミアム発表に採択され、実機の展示による発表をしました。', image: '/images/Interaction2024.jpg' },
            { title: '第19回学生天国出展', description: 'IVRC2023出展作品「それいけ！ムササビスーツ」の出展を行いました。', image: '/images/GakuseiTengoku2024.jpg' },
            { title: '本学八王子祭出展', description: 'IVRC2023出展作品「それいけ！ムササビスーツ」の出展を行いました。'},
            { title: '本学新宿祭出展', description: 'IVRC2024出展作品「Gravity Paradox」の出展を行いました。', image: '/images/ShinjukuFes_Contest.JPG' },
          ],
        },
      ],
    },
    metaverse: {
      title: 'メタバースチーム',
      image: '/images/Metaverse2024.jpg',
      overview: `メタバースチームは、「既存の建物」「失われた建物」などを仮想空間上に再現する取り組みをしております。
建造物の設計図から3Dオブジェクトとしてモデリングをし、メタバースなど3Dの空間上に再現する取り組みをしております。
メタバースシステムを自分たちで開発することで、「学生のニーズに合わせた」メタバースシステムの開発をしております。
「学生のニーズに合わせた」メタバースシステムを新入生歓迎会など、様々な行事に活用することで「作ったものに求められるニーズ」を適切に見極めて実現していきます。
メタバースチームでの経験は、将来の研究や就職活動において活きてくる「問題を見極める力」や「開発能力」「管理能力」「他者への提案能力」などを養えます。`,
      activities: [
        {
          year: '2020',
          items: [
            { title: 'VRキャンパスプロジェクト始動', description: 'VR空間で見れる「VR八王子キャンパス ver1.0」のリリースに向け、制作を始めました。', image: '/images/VRHachioji2022.jpg' },
            { title: 'VRキャンパス ver1.0リリース', description: 'VR空間で見れる「VR八王子キャンパス ver1.0」が完成しました。' },
          ],
        },
        {
          year: '2022',
          items: [
            { title: '旧図書館再現プロジェクト始動', description: '「八王子キャンパス旧図書館」を3Dオブジェクトとして再現するプロジェクトが始まりました。', image: '/images/OldLibrary2022.jpg' },
            { title: 'VRキャンパス ver2.0リリース', description: 'メタバースプラットフォーム「DOOR」で見れる「VR八王子キャンパス ver2.0」が完成しました。', image: '/images/VRHachiojiver2.jpg' },
          ],
        },
        {
          year: '2023',
          items: [
            { title: '旧図書館3D再現完成', description: '貴重な建造物「八王子キャンパス旧図書館」を設計図から3Dオブジェクトとして再現しました。', image: '/images/OldLibrary2023.jpg' },
            { title: 'オープンキャンパス展示', description: '「八王子キャンパス旧図書館」の3Dオブジェクトを、VRゴーグルを用いて展示しました。' },
            { title: '本学八王子祭展示', description: '「八王子キャンパス旧図書館」の3Dオブジェクトを展示しました。' },
            { title: '本学新宿祭展示', description: '「八王子キャンパス旧図書館」の3Dオブジェクトを展示しました。' },
            { title: 'VRキャンパス改良開始', description: '自分たちで開発したメタバースシステム上に再現し、学校行事に導入できるようにします。' },
          ],
        },
        {
          year: '2024',
          items: [
            { title: 'VRキャンパス改良プロジェクト', description: '自分たちで開発したメタバースシステム上に再現し、学校行事に導入できるようにします。', image: '/images/Metaverse2024-1.jpg' },
            { title: 'メタバースシステム開発', description: 'コミュニケーションなどがとれるよう、メタバースシステムを開発しております。', image: '/images/Metaversesystem2024.png' },
            { title: 'オープンキャンパス展示', description: '「八王子キャンパス旧図書館」の3Dオブジェクトを、VRゴーグルを用いて展示しました。' },
            { title: '本学八王子祭展示', description: '「八王子キャンパス旧図書館」の3Dオブジェクトを展示しました。' },
            { title: '本学新宿祭展示', description: '「八王子キャンパス旧図書館」の3Dオブジェクトを展示しました。', image: '/images/squareImg02.png' },
          ],
        },
      ],
    },
    vtuber: {
      title: 'VTuberチーム',
      image: '/images/VTuber2024.jpg',
      overview: `VTuberチームでは、「自分たちにしかできない」VTuberコンテンツを制作、発信しております。
VTuberキャラクターや動画企画を一から考案し、一から制作しております。
本学にある高精度なモーションキャプチャ設備、およびウェブカメラを用いたカメラトラッキングを用いた撮影をし、動画編集を経て一つの動画を作ります。
動画を発信した後、「コンテンツに対しどのような需要があるのか?」を考慮し、日々制作、発信に取り組んでおります。
VTuberチームでの経験は、研究や就活など将来に対し、「多くの人への発信能力」や「プレゼン能力」「傾聴力」などに活きていきます。`,
      activities: [
        {
          year: '2021以前',
          items: [
            { title: 'VRちゃんキャラクター制作', description: '2019年に登場したVTuberキャラクター「VRちゃん」を制作しました。', image: '/images/VRChan.png' },
            { title: 'VRちゃんシステム実装', description: '「VR八王子キャンパス」システムでの操作キャラクターとして実装しました。', image: '/images/Shinjuku_VTuber2021-1.png' },
            { title: 'VRちゃん動画制作・配信', description: 'VRちゃんの紹介動画を作りました。(現在は非公開)', image: '/images/squareImg03.png' },
          ],
        },
        {
          year: '2022',
          items: [
            { title: 'メンダコキャラクター制作', description: '2022年に登場したメンダコを制作しました。', image: '/images/mendako_toon.png' },
            { title: 'VTuberチーム正式始動', description: '企画、モーションキャプチャや既存ソフトを組み合わせた配信環境を用いて、撮影、動画編集、配信、運用を一貫して行う現在のチームを始動しました。', image: '/images/VTuber2022.jpg' },
            { title: '有志による技術開拓', description: '学部1年～修士1年までの有志達が、撮影方法から配信方法までの技術開拓を始めました。', image: '/images/VTuber2022-1.jpg' },
          ],
        },
        {
          year: '2023',
          items: [
            { title: 'すぅちゃんキャラクター制作', description: 'すぅちゃんというキャラクターの制作をしました。', image: '/images/photo06.jpg' },
            { title: 'VTuber配信活動', description: '企画から、モーションキャプチャや既存ソフトを組み合わせた撮影、動画編集、配信、運用を一貫して行いました。', image: '/images/squareImg03.png' },
            { title: '第18回学生天国出展', description: 'Kinect v1及びMikuMikuCaptureを用いた全身トラッキング、VSeeaFaceを用いたフェイシャルトラッキングの出来るコンテンツの出展を行いました。', image: '/images/GakuseiTengoku2024.jpg' },
            { title: '本学新宿祭出展', description: 'TDPTを用いた全身トラッキングの出来るコンテンツの出展を行いました。', image: '/images/Shinjuku_VTuber2023-1.png' },
          ],
        },
        {
          year: '2024',
          items: [
            { title: '新VTuberキャラクター制作', description: '2025年度以降に登場する新たなキャラクターの制作を始めました。', image: '/images/VTuber2024-1.jpg' },
            { title: 'こども科学センターワークショップ', description: '東京都渋谷区にあるこども科学センターハチラボにて、VTuberのキャラクターを手軽に作り、操作できるワークショップを開催しました。', image: '/images/VTuberWorkshop2025.jpg' },
            { title: 'VTuber配信活動', description: '企画から、モーションキャプチャや既存ソフトを組み合わせた撮影、動画編集、配信、運用を一貫して行いました。', image: '/images/VTuberMake2024.jpg' },
            { title: '第19回学生天国出展', description: 'WebCamMotion Captureを用いたフェイシャルトラッキングの出来るコンテンツの出展を行いました。', image: '/images/GakuseiTengoku2024.jpg' },
            { title: '本学新宿祭出展', description: 'WebCamMotion Captureを用いた全身トラッキングの出来るコンテンツの出展を行いました。', image: '/images/Shinjuku_VTuber2024.jpg' },
            { title: '八王子OPA出展', description: '八王子市内の商業施設「OPA」にてWebCamMotion Captureを用いたフェイシャルトラッキングの出来るコンテンツの出展を行いました。', image: '/images/OPA2024_VTuber.jpg' },
          ],
        },
      ],
    },
  },
  joinUs: {
    title: '入部について',
    description: `多種多様な知識や考えの「融合」、それがXRにはもちろん、
弊団体の更なる成長に必要だと考えます。
本プロジェクトは、そんなXRの未来を一緒に創る仲間を学部・学年問わず歓迎します！`,
    howToJoin: `入部をご希望の方は、下記の公式LINEを友だち追加し、
案内に従って入部手続きを進めてください。
YouTube動画では、入部手続きの手順を紹介しています。
ご不明な点やトラブルがございましたら、メールまでお問い合わせください。`,
    qrCodeImage: 'https://qr-official.line.me/gs/M_523ytzrw_GW.png?ts=04011002&oat_content=url',
    links: [
      { text: '公式LINEのリンク', url: 'https://lin.ee/n5khb4O' },
      { text: '動画のリンク', url: 'https://www.youtube.com/shorts/sN261Aj9pfk' },
    ],
    contactEmail: 'vrproject@cc.kogakuin.ac.jp',
  },
  organizationInfo: {
    title: '団体情報',
    details: [
      { label: '団体名', value: '工学院大学VRプロジェクト' },
      { label: '団体属性', value: '学生プロジェクト(学生団体)' },
      { label: '学生代表', value: '北川大智' },
      { label: '顧問', value: '吉田直人' },
      { label: '住所', value: '東京都八王子市中野町2665-1' },
      { label: 'メールアドレス', value: 'vrproject@cc.kogakuin.ac.jp' },
      { label: '設立', value: '2019年4月1日' },
      { label: '在籍人数', value: '105名(2025年3月31日時点)' },
      { label: '所属大学', value: '学校法人工学院大学' },
    ],
    advisorLink: 'https://er-web.sc.kogakuin.ac.jp/Profiles/25/0002484/profile.html',
    universityLink: 'https://www.kogakuin.ac.jp/',
  },
  events: {
    title: 'その他の活動',
    items: [
      { title: 'ARコンテンツ開発', description: '2024年度より新たにARコンテンツの開発を始めました。拡張現実技術を活用した革新的なコンテンツ制作に取り組んでいます。', image: '/images/TeamAR2024.png' },
      { title: '学会発表', description: '活動内で得られた成果を基に、国内外の学会にて発表を行います。学術的な知見の共有と技術向上を目指しています。', image: '/images/conference.jpg' },
      { title: '学外展示', description: '八王子市や、国内で行われる数多くのイベントに出展します。地域との連携を深め、技術の普及に貢献しています。', image: '/images/HachiojiOpa2024_Contest.JPG' },
      { title: '万博出展', description: '2025年、企業や一般社団法人とともに大阪万博に「共創」という形で出展します。世界に向けて私たちの技術を発信します。', image: '/images/TeamExpo2025.JPG' },
    ],
  },
  news: {
    title: 'NEWS',
    // Placeholder for news items, will be populated statically for now
    items: [
      { date: '2025-09-17', text: 'IVRC2025 SEEDステージに出場しました。' },
      { date: '2025-09-06', text: '八王子祭に出展しました。' },
      { date: '2025-08-24', text: '八王子OPAにメタバースチームが出展しました。' },
      { date: '2025-07-28', text: '大阪万博関西パビリオンに出展しました。' },
    ],
  },
};

export default content;